import React, { FC, PropsWithChildren } from 'react';
import { PageTitle } from '@app/components/PageTitle';
import { Box, Button, HStack } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { APP_ROUTES } from '@app/constants/routes';
import Metadata from '@app/components/Metadata';
import AnimatedLayout from '@app/layouts/AnimatedLayout/AnimatedLayout';
import { useConfig } from '@app/config';
import Router from '@app/assets/images/logo/router.svg';
import RouterW from '@app/assets/images/logo/router_w.svg';
import { Tooltip } from '@app/components/Tooltip';

const AddLiquidityLayout: FC<PropsWithChildren> = ({ children }) => {
  const router = useRouter();
  const config = useConfig();

  const isV4View = router.pathname === APP_ROUTES.addLiquidityV4;
  const isV2View = router.pathname === APP_ROUTES.addLiquidityV2;
  const isRouterView = router.pathname === APP_ROUTES.addLiquidityRouter;

  return (
    <AnimatedLayout>
      <Metadata title={'Liquidity | Kim'} />
      <Box width="100%" mt={8} px={[0, 7]}>
        <PageTitle
          title="Add liquidity"
          subtitle="Create positions into pools to earn swap fees"
        >
          <HStack
            my={[4, 8]}
            width={['100%', 'fit-content']}
            sx={{
              '> a': {
                width: ['100%', 'fit-content']
              }
            }}
          >
            <Link href={APP_ROUTES.addLiquidityV4}>
              <Button
                variant="tertiary"
                sx={{
                  padding: '12px 24px',
                  color: isV4View ? 'orange' : 'gray.4',
                  bg: isV4View ? 'gray.2' : 'transparent'
                }}
              >
                V4
              </Button>
            </Link>
            <Link href={APP_ROUTES.addLiquidityV2}>
              <Button
                variant="tertiary"
                sx={{
                  padding: '12px 24px',
                  color: isV2View ? 'orange' : 'gray.4',
                  bg: isV2View ? 'gray.2' : 'transparent'
                }}
              >
                V2
              </Button>
            </Link>
            {config?.FLAGS.showRouterIntentPage && (
              <Link href={APP_ROUTES.addLiquidityRouter}>
                <Tooltip tooltip="Add liquidity into Kim from any chain using any token.">
                  <Button
                    variant="router"
                    isActive={isRouterView}
                    sx={{
                      color: isRouterView ? 'white' : '#CB0766',
                      bg: isRouterView ? '#CB0766' : 'gray.2',
                      ml: 1
                    }}
                  >
                    {isRouterView ? <RouterW /> : <Router />}
                  </Button>
                </Tooltip>
              </Link>
            )}
          </HStack>
        </PageTitle>
        <Box mt={8} width="100%">
          {children}
        </Box>
      </Box>
    </AnimatedLayout>
  );
};

export default AddLiquidityLayout;
